// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";

// Plugins
import lodash from "lodash";
import VueI18n from 'vue-i18n';
import * as VueGoogleMaps from 'vue2-google-maps';
// import Headful from "headful";
// import vueScrollto from 'vue-scrollto'
import VueCookies from 'vue-cookies'



Vue.use(VueI18n);
Vue.use(VueCookies);

Vue.set(Vue.prototype, "$lodash", lodash);


// ===================
// 	Blocks
// ===================

require('@/components/blocks/blocks.js')


// ===================
// 	Translations
// ===================

const messages = require('@/data/translations.json');

export const i18n = new VueI18n({
	locale: 'en',
	messages
})

// ===================
// 	Google Maps
// ===================

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyCVOPuZgLD4SPekFvVXSUhMkMt5XTMnXrU',
		libraries: 'places', // This is required if you use the Autocomplete plugin
	},
})

// ===================
// 	Helpers
// ===================

import { transform } from '@/data/helpers/date-pipe.js';
import { stripHtml } from '@/data/helpers/strip-html.js';


// ===================
//  Filters
// ===================

Vue.filter("date", transform)

Vue.filter("stripHtml", function(data) {
	if (typeof data !== "string") return "";
	var doc = new DOMParser().parseFromString(data, "text/html");
	return doc.body.textContent || "";
});


/*
* 	Global event bus.
*/
export const bus = new Vue();


/**
 * Vue Initialization.
 */

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	template: "<App/>",
	components: { App },
	i18n,
});



// WEBPACK FOOTER //
// ./src/main.js